import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import CheckIcon from "@mui/icons-material/Check";
import { useDispatch, useSelector } from "react-redux";
import { cancelManagerFromProject } from "../../../../../store/slices/cancelManagerSlice";
import { useSnackbar } from "notistack";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { fetchEmployeeGroups } from "../../../../../store/slices/employeeGroup";
import { assignProject, directAcceptProject } from "../../../../../store/slices/projectAssignedSlice";
import ShowApprovedTaskDetails from "./ShowApprovedTaskDetails";
import ActionForwardApproved from "./ActionForwardApproved";
import { buildSalespersonProjectApprovedAssignPayload } from "./AssignManagers";
import CheckIcon from "@mui/icons-material/Check";
import { fetchWorkEntriesProjectTracking } from "../../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasksProjectTracking } from "../../../../../store/slices/DescriptionTask";
import { fetchHardwareProjectTracking } from "../../../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
// import { updatePrimaryResourcesAfterAssigned } from "../../../../../store/slices/updatePrimaryResourcesAfterAssignedSlice";



const ProjectApprovedSub = ({ handleparentrefresh, rowData, row, setIsLoading, isViewOnly = false }) => {
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const { groups } = useSelector((state) => state.employeeGroup);
    const { entries } = useSelector((state) => state.workentries);
    const { tasks } = useSelector((state) => state.descriptionTasks);
    const { items } = useSelector((state) => state.hardwareDescription);

    const { employees } = useSelector((state) => state.employees);
    const { projectTrackingWorkEntries } = useSelector(
        (state) => state.workentries
    );
    const { hardwareProjectTracking } = useSelector(
        (state) => state.hardwareDescription
    );
    const { descriptionProjectTracking } = useSelector(
        (state) => state.descriptionTasks
    );




    useEffect(() => {
        dispatch(fetchWorkEntriesProjectTracking());
        dispatch(fetchDescriptionTasksProjectTracking());
        dispatch(fetchHardwareProjectTracking());
        dispatch(fetchEmployees());
        dispatch(getMyTrainings());
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchEmployeeGroups());
        dispatch(fetchAllProjects());
    }, [dispatch]);

    const [loggedEmp, setLoggedEmp] = useState(null);

    useEffect(() => {
        const EmailLogged = localStorage.getItem('email');
        const Emp = employees?.find((emp) => emp?.EmpEmail === EmailLogged);
        setLoggedEmp(Emp)
    }, [employees])

    const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
    const [showEmpAssignedDrop, setShowEmpAssignedDrop] = useState(null);
    const [newEmpOpenDropdownIndex, setNewEmpOpenDropdownIndex] = useState(null);
    const [popupEmpOpenDropdownIndex, setPopupEmpOpenDropdownIndex] = useState(null);

    const [cancelProject, setcancelProject] = useState();
    const [confirmAssignPopup, setconfirmAssignPopup] = useState(false);

    const dropdownRefsProbability = useRef([]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                openProbabilityIndex !== null &&
                dropdownRefsProbability.current[openProbabilityIndex] &&
                !dropdownRefsProbability.current[openProbabilityIndex].contains(
                    event.target
                )
            ) {
                setOpenProbabilityIndex(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openProbabilityIndex]);

    // const [selectedPrimaryResourceList, setSelectedPrimaryResourceList] = useState({});
    const [addMemberEmpList, setAddMemberEmpList] = useState([]);
    const [, setSelectedIndex] = useState(null);
    const [assignedPeopleList, setAssignedPeopleList] = useState([]);
    const [newAssignedPeopleList, setNewAssignedPeopleList] = useState({});
    const [popupassignedPeopleList, setpopupassignedPeopleList] = useState([]);
    useEffect(() => {

        if (groups?.length && loggedEmp) {

            const EmailLogged = localStorage.getItem('auth');

            if (EmailLogged === "L0" || EmailLogged === "L1") {
                setAddMemberEmpList(groups);
            } else {
                const loggedCreatedBy = groups.filter(
                    (emp) =>
                        emp?.createdBy?._id === loggedEmp?._id
                );
                setAddMemberEmpList(loggedCreatedBy);
            }

        }
    }, [groups, loggedEmp]);

    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowEmpAssignedDrop(null);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const newEmpDropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                newEmpDropdownRef.current &&
                !newEmpDropdownRef.current.contains(event.target)
            ) {
                setNewEmpOpenDropdownIndex(null);
                setPopupEmpOpenDropdownIndex(null)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);



    const managerDropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                managerDropdownRef.current &&
                !managerDropdownRef.current.contains(event.target)
            ) {
                setOpenMenuIdx(null); // close on outside click
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [, setOpenMenuIdx] = useState(null);
    const resolveId = useCallback((value) => {
        if (!value) return "";
        if (typeof value === "string") return value;
        return value?._id || value?.id || "";
    }, []);

    const getGroupIdFromProject = useCallback(
        (projectObj) => resolveId(projectObj?.groupid) || resolveId(row?.groupid),
        [resolveId, row?.groupid]
    );

    const rowGroupId = useMemo(() => resolveId(row?.groupid), [resolveId, row?.groupid]);

    const newManagerActionMenuKey = useMemo(
        () => `newManager_${String(row?.ProjectName || "")}_${String(rowGroupId || "")}`,
        [row?.ProjectName, rowGroupId]
    );

    const getFilteredEmployees = (typeService, groupId) => {
        if (!addMemberEmpList?.length) return [];

        return addMemberEmpList
            .filter(
                (emp) => resolveId(emp.groupId) === resolveId(groupId)
            )
            .filter(
                (emp) =>
                    emp.employeeId?.servicetype?.trim().toLowerCase() ===
                    typeService?.trim().toLowerCase()
            );
    };

    const handleAssignProject = async (proj) => {
        if (isViewOnly) return;
        const projectKey = `${proj._id}_${proj.TypeService}`;
        const matchedEntry = assignedPeopleList[projectKey];
        const assignData = buildSalespersonProjectApprovedAssignPayload(
            proj,
            matchedEntry,
            employees
        );
        setIsLoading(true);
        try {
            await dispatch(assignProject(assignData));
            enqueueSnackbar("Project Assigned Successfully", {
                variant: "success",
            });
            setIsLoading(false);
        } catch {
            enqueueSnackbar("Project Assigned Failed", { variant: "error" });
        } finally {
            setIsLoading(false);
            dispatch(fetchAllProjects());
            dispatch(fetchWorkEntriesProjectTracking());
            dispatch(fetchDescriptionTasksProjectTracking());
            dispatch(fetchHardwareProjectTracking());
            setAssignedPeopleList([])
            handleparentrefresh()
        }
    };

    const handleDirectAcceptProject = async (proj) => {
        if (isViewOnly) return;
        const projectKey = `${proj._id}_${proj.TypeService}`;
        const matchedEntry = assignedPeopleList[projectKey];
        const assignData = buildSalespersonProjectApprovedAssignPayload(
            proj,
            matchedEntry,
            employees
        );
        setIsLoading(true);
        try {
            await dispatch(directAcceptProject(assignData)).unwrap();
            enqueueSnackbar("Project accepted successfully", {
                variant: "success",
            });
            setIsLoading(false);
        } catch {
            enqueueSnackbar("Project accept failed", { variant: "error" });
        } finally {
            setIsLoading(false);
            dispatch(fetchAllProjects());
            dispatch(fetchWorkEntriesProjectTracking());
            dispatch(fetchDescriptionTasksProjectTracking());
            dispatch(fetchHardwareProjectTracking());
            setAssignedPeopleList([]);
            handleparentrefresh();
        }
    };




    const handleAssignNewManagerProject = async () => {
        if (isViewOnly) return;
        const matchedProject = rowData.find(
            (proj) => proj.projectName === row?.ProjectName
        );

        setIsLoading(true);
        try {
            // Get all the people from the object (assuming there might be multiple groups)
            const allPeople = Object.values(newAssignedPeopleList).flat();

            // Create an array of promises for each API call
            const apiCalls = allPeople.map(async (person) => {
                const assignData = {
                    projectName: row?.ProjectName,
                    quotationId: row?.quotationId || matchedProject?.quotationId,
                    targetManagerId: person.emp?.employeeId?._id, // single ID
                    serviceType: person.emp?.employeeId?.servicetype, // single service type
                    ProjectDueDate: matchedProject?.ProjectDueDate || ""
                };

                // Make API call for each person
                await dispatch(assignProject(assignData));
            });

            // Wait for all API calls to complete
            await Promise.all(apiCalls);

            enqueueSnackbar("All Projects Assigned Successfully", {
                variant: "success",
            });
        } catch (error) {
            console.error("Assignment error:", error);
            enqueueSnackbar("Some Project Assignments Failed", { variant: "error" });
        } finally {
            setIsLoading(false);
            dispatch(fetchAllProjects());
            setShowEmpAssignedDrop(null)
            setNewAssignedPeopleList({})
            dispatch(fetchEmployeeGroups());
            HandleEmployeerefresh()
            setOpenProbabilityIndex(null);
            handleparentrefresh()
        }
    };

    const handleDirectAcceptNewManagerProject = async () => {
        if (isViewOnly) return;
        const matchedProject = rowData.find(
            (proj) => proj.projectName === row?.ProjectName
        );

        setIsLoading(true);
        try {
            const allPeople = Object.values(newAssignedPeopleList).flat();

            const apiCalls = allPeople.map(async (person) => {
                const assignData = {
                    projectName: row?.ProjectName,
                    quotationId: row?.quotationId || matchedProject?.quotationId,
                    targetManagerId: person.emp?.employeeId?._id,
                    serviceType: person.emp?.employeeId?.servicetype,
                    ProjectDueDate: matchedProject?.ProjectDueDate || ""
                };

                await dispatch(directAcceptProject(assignData)).unwrap();
            });

            await Promise.all(apiCalls);

            enqueueSnackbar("All projects accepted successfully", {
                variant: "success",
            });
        } catch (error) {
            console.error("Direct accept error:", error);
            enqueueSnackbar("Some project accepts failed", { variant: "error" });
        } finally {
            setIsLoading(false);
            dispatch(fetchAllProjects());
            setShowEmpAssignedDrop(null)
            setNewAssignedPeopleList({})
            dispatch(fetchEmployeeGroups());
            HandleEmployeerefresh()
            setOpenProbabilityIndex(null);
            handleparentrefresh()
        }
    };


    const HandleEmployeerefresh = () => {
        const matchingPerson = addMemberEmpList.filter(group =>
            row.TypeService.includes(group?.employeeId?.servicetype)
        );

        const matchingGroups = matchingPerson.filter(
            (group) => resolveId(group?.groupId) === rowGroupId
        );
        setFilteredNewEmployees(matchingGroups);

    };


    const HandleManagerCancel = async (proj) => {
        if (isViewOnly) return;
        if (proj.oldprojectid) {
            setconfirmAssignPopup(true)

        } else {
            ManagerCancel(proj)
        }
    };

    const modalManagerCancel = async () => {
        if (isViewOnly) return;
        await handleAssignProjectnew(cancelProject);
        await ManagerCancel(cancelProject);
        setconfirmAssignPopup(false);                // close popup last
    };


    const handleAssignProjectnew = async (proj) => {
        if (isViewOnly) return;
        const projectKey = `${proj?.ProjectName}_${getGroupIdFromProject(proj)}`;
        // Get the array for this specific project
        const projectArray = popupassignedPeopleList[projectKey];
        // Get the first entry (or you can modify this logic if there are multiple entries)
        const matchedEntry = projectArray ? projectArray[0] : null;
        const assignData = {
            projectName: proj?.ProjectName,
            quotationId: proj?.quotationId,
            serviceType: proj?.TypeService,
            projectId: proj?.oldprojectid,
            targetManagerId: matchedEntry?.emp?.employeeId?._id, // This should work now
        };
        setIsLoading(true);
        try {
            await dispatch(assignProject(assignData));
            enqueueSnackbar("Project Assigned Successfully", {
                variant: "success",
            });
            dispatch(fetchAllProjects());
        } catch {
            enqueueSnackbar("Project Assigned Failed", { variant: "error" });
        } finally {
            setIsLoading(false);
            setcancelProject();
            setPopupEmpOpenDropdownIndex(null)
            setpopupassignedPeopleList({})
        }
    };

    const ManagerCancel = async (proj) => {
        const projectId = proj?._id;
        setIsLoading(true);
        try {
            await dispatch(cancelManagerFromProject(projectId)).unwrap();
            enqueueSnackbar("Manager Cancelled Successfully", {
                variant: "success",
            });
            setIsLoading(false);
        } catch (error) {
            console.error("Failed to create task:", error);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            HandleEmployeerefresh()
            setPopupEmpOpenDropdownIndex(null)
            setpopupassignedPeopleList({})
        }
        dispatch(fetchAllProjects());
    };
    const [filteredNewEmployees, setFilteredNewEmployees] = useState([])
    const [popupfilteredNewEmployees, setpopupfilteredNewEmployees] = useState([])
    const [uniqueEmployeesnew, setUniqueEmployeesnew] = useState([]);

    console.log("approved1 groups", groups);
    console.log("approved1 filteredNewEmployees", filteredNewEmployees);
    console.log("approved1 uniqueEmployeesnew", uniqueEmployeesnew);

    useEffect(() => {
        if (filteredNewEmployees?.length) {
            const salesMember = filteredNewEmployees.filter((emp) => emp?.createdBy?.EmpEmail === loggedEmp?.EmpEmail)
            const uniqueList = salesMember.filter(
                (emp, index, self) =>
                    index ===
                    self.findIndex(
                        (e) => e?.employeeId?._id === emp?.employeeId?._id // ✅ dedupe by employeeId
                    )
            );
            setUniqueEmployeesnew(uniqueList);
        } else {
            setUniqueEmployeesnew([]);
        }
    }, [filteredNewEmployees, loggedEmp]);


    useEffect(() => {
        // Filter employees based on service type matching
        const matchingEmployees = filteredNewEmployees.filter(employee =>
            employee.employeeId?.servicetype === cancelProject?.TypeService
        );
        setpopupfilteredNewEmployees(matchingEmployees)
    }, [filteredNewEmployees, cancelProject]);

    const popupuniqueEmployeesnew = popupfilteredNewEmployees.filter(
        (emp, index, self) =>
            index === self.findIndex(
                (e) =>
                    e.employeeId?._id === emp?.employeeId?._id // dedupe by employee ID
            )
    );


    useEffect(() => {

        if (row?.projects?.length && addMemberEmpList?.length) {

            const result = row.projects.flatMap((proj) =>
                addMemberEmpList.filter((emp) => {
                    // Check if employee's groups include the project group
                    const hasMatchingGroup =
                        resolveId(emp?.groupId) === getGroupIdFromProject(proj);

                    // Check if project's TypeService includes employee's servicetype
                    // Note: row.TypeService is an array, so we check if it includes the employee's servicetype
                    const employeeService = emp.employeeId?.servicetype?.trim().toLowerCase();
                    const projectServices = row.TypeService || []; // This is from the main row object
                    const hasMatchingService = projectServices.some(
                        service => service?.trim().toLowerCase() === employeeService
                    );

                    return hasMatchingGroup && hasMatchingService;
                })
            );


            // Step 2: Collect already assigned emails
            const assignedEmails =
                row?.projects?.flatMap(
                    (proj) => proj.Assignedperson?.map((p) => p.email) || []
                ) || [];

            // Step 3: Filter out employees already assigned by email
            let filtered = result.filter(
                (emp) => !assignedEmails.includes(emp.employeeId?.EmpEmail)
            );

            // Step 4: Exclude employees whose servicetype is already assigned in assignedFiltered
            const assignedFiltered = row?.managerAssignedProject || [];
            const assignedTypes = assignedFiltered.map((proj) =>
                proj.TypeService?.trim().toLowerCase()
            );

            filtered = filtered.filter(
                (emp) =>
                    !assignedTypes.includes(
                        emp.employeeId?.servicetype?.trim().toLowerCase()
                    )
            );
            setFilteredNewEmployees(filtered);
        }
        else {
            // FIX: row.TypeService is an array, we need to check if it includes the employee's servicetype
            const matchingPerson = addMemberEmpList?.filter(empItem => {
                const employee = empItem.employeeId;
                // Check if employee's servicetype is in row.TypeService array
                const hasMatchingService = row?.TypeService?.includes(employee?.servicetype);
                const hasMatchingGroup = resolveId(empItem?.groupId) === rowGroupId;
                return hasMatchingService && hasMatchingGroup;
            });
            setFilteredNewEmployees(matchingPerson || []);
        }
    }, [row, addMemberEmpList, getGroupIdFromProject, rowGroupId, resolveId]);

    const isDisabled = Object.keys(popupassignedPeopleList).length === 0;

    return (
        <div className="w-full">
            {row.projects?.map((proj, index) => {
                const uniqueKey = `${index}_${proj.TypeService}_${proj._id}`;
                const filteredEmployees = getFilteredEmployees(
                    proj.TypeService,
                    getGroupIdFromProject(proj)
                );
                const projectKey = `${proj._id}_${proj.TypeService}`;
                const uniqueEmployees = filteredEmployees.filter(
                    (emp, index, self) =>
                        index === self.findIndex(
                            (e) =>
                                e.employeeId._id === emp.employeeId._id // dedupe by employee ID
                        )
                );
                return (
                    <div className="flex align-middle items-center  border-b">
                        <div className=" flex w-36 h-full justify-center align-middle items-center">
                            <>
                                {proj.Assignedperson.some((person) =>
                                    person.salespersonstatus === "project approved" &&
                                    person.managerstatus === "project assigned"
                                )
                                    ? (
                                        <div className=" rounded-md relative flex justify-between text-xs align-middle items-center w-full px-2">

                                            {proj.Assignedperson.find((person) =>
                                                person.salespersonstatus === "project approved" &&
                                                person.managerstatus === "project assigned"
                                            ) && (
                                                    <>

                                                        {
                                                            (
                                                                proj.Assignedperson.find((person) =>
                                                                    person.salespersonstatus === "project approved" &&
                                                                    person.managerstatus === "project assigned"
                                                                )?.name
                                                            ) || "Select Option"
                                                        }
                                                    </>
                                                )}
                                            {(() => {
                                                // Step 1: Find the project manager in Assignedperson
                                                const pm = proj?.Assignedperson?.find((person) =>
                                                    employees.some(
                                                        (emp) =>
                                                            emp.EmpEmail === person.email &&
                                                            emp.customRoles?.includes("project manager")
                                                    )
                                                );


                                                if (
                                                    (pm?.salespersonaction === "reject" && pm?.projecttracktaskStatus === "pending" && pm?.taskStatus === "pending")

                                                ) {
                                                    return (
                                                        <span
                                                            title="Rejected"
                                                            className="text-red-700 text-xl font-bold px-1 ml-2 rounded"
                                                        >
                                                            !
                                                        </span>
                                                    );
                                                }


                                                // Step 2: Check multiple conditions
                                                if (
                                                    (pm?.projecttracktaskStatus === "pending" || pm?.projecttracktaskStatus === "submit") &&
                                                    pm?.taskStatus !== "submit" && pm?.salespersonaction !== "reject"
                                                ) {
                                                    return (
                                                        <span
                                                            title="Pending"
                                                            className="text-orange-500 text-xl font-bold px-1 ml-2 rounded"
                                                        >
                                                            !
                                                        </span>
                                                    );
                                                }

                                                return null; // nothing to render if conditions not met
                                            })()}



                                            {(() => {
                                                const manager = proj?.Assignedperson?.find((person) =>
                                                    employees.some(
                                                        (emp) =>
                                                            emp.EmpEmail === person.email &&
                                                            emp.customRoles?.includes("project manager")
                                                    )
                                                );

                                                return (
                                                    manager?.projecttracktaskStatus === "submit" &&
                                                    manager?.taskStatus === "submit" &&
                                                    manager?.manageraction === "complete" && (
                                                        <span
                                                            title="Completed"
                                                            className="text-green-500 text-xl font-bold px-1 ml-2 rounded"
                                                        >
                                                            <CheckIcon />
                                                        </span>
                                                    )
                                                );
                                            })()}

                                        </div>
                                    )
                                    : (
                                        <div
                                            className="w-[80%]  rounded-md relative flex justify-center text-xs align-middle items-center border border-gray-300">
                                            <button
                                                disabled={isViewOnly}
                                                onClick={() => {
                                                    if (isViewOnly) return;
                                                    setShowEmpAssignedDrop(
                                                        showEmpAssignedDrop === uniqueKey ? null : uniqueKey
                                                    ); setSelectedIndex(index);
                                                }}
                                                className={`w-full text-xs p-2 truncate flex justify-between items-center ${isViewOnly ? "cursor-not-allowed opacity-50" : ""}`}
                                            >
                                                {assignedPeopleList[projectKey]?.emp?.employeeId ? (
                                                    // case 1: assignedPeopleList has value
                                                    `${assignedPeopleList[projectKey].emp.employeeId.EmpFirstName} ${assignedPeopleList[projectKey].emp.employeeId.EmpLastName}`
                                                ) : proj.AssignedManagerEmail?.[0] ? (
                                                    // case 2: fallback to manager if present
                                                    (() => {
                                                        const managerEmp = filteredEmployees.find(
                                                            (emp) => emp.employeeId?.EmpEmail === proj.AssignedManagerEmail[0]
                                                        );
                                                        return managerEmp
                                                            ? `${managerEmp.employeeId?.EmpFirstName} ${managerEmp.employeeId?.EmpLastName}`
                                                            : "Select Resource";
                                                    })()
                                                ) : (
                                                    // case 3: nothing found
                                                    "Select Resource"
                                                )}


                                            </button>

                                            <ExpandMoreIcon
                                                onClick={() => {
                                                    if (isViewOnly) return;
                                                    setShowEmpAssignedDrop(
                                                        showEmpAssignedDrop === uniqueKey ? null : uniqueKey
                                                    );
                                                }}
                                                className={`ml-1 absolute right-0 bg-white ${isViewOnly ? "cursor-not-allowed opacity-50" : "cursor-pointer group-hover:bg-gray-100"}`}
                                            />

                                            {showEmpAssignedDrop === uniqueKey && (
                                                <div
                                                    ref={dropdownRef}
                                                    className="absolute top-full left-0  max-w-26 max-h-52 overflow-y-auto bg-white border border-gray-300 shadow-lg z-50 narrow-scrollbar">
                                                    { }
                                                    {uniqueEmployees.length > 0 ? (
                                                        // uniqueEmployees
                                                        //     .map((emp) => {
                                                        uniqueEmployees
                                                            .filter(emp => emp.employeeId?.EmpEmail !== proj.AssignedManagerEmail?.[0])
                                                            .map((emp) => {
                                                                const fullName = `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`;
                                                                const empEmail = emp.employeeId?.EmpEmail;
                                                                const projectKey = `${proj._id}_${proj.TypeService}`;

                                                                return (
                                                                    <label
                                                                        key={emp.employeeId?.id || emp.employeeId?._id}
                                                                        className={`flex justify-between align-middle items-center px-2 py-1 text-xs ${proj.AssignedManagerEmail?.[0] === empEmail
                                                                            ? "bg-blue-300 font-semibold"
                                                                            : "bg-white hover:bg-gray-100"
                                                                            }`}                      >


                                                                        <input
                                                                            type="checkbox"
                                                                            className="mr-2"
                                                                            disabled={isViewOnly}
                                                                            value={fullName}
                                                                            checked={assignedPeopleList[projectKey]?.email === empEmail}
                                                                            onChange={(e) => {
                                                                                if (isViewOnly) return;
                                                                                const selectedValue = { name: fullName, email: empEmail, emp: emp };
                                                                                const isChecked = e.target.checked;

                                                                                setAssignedPeopleList((prev) => {
                                                                                    if (isChecked) {
                                                                                        return { ...prev, [projectKey]: selectedValue };
                                                                                    } else {
                                                                                        const newState = { ...prev };
                                                                                        delete newState[projectKey];
                                                                                        return newState;
                                                                                    }
                                                                                });
                                                                            }}
                                                                        />

                                                                        {fullName}

                                                                    </label>
                                                                );
                                                            })
                                                    ) : (
                                                        <div className="px-2 py-1 text-gray-500">
                                                            No matching resources found.
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                    )}
                            </>
                        </div>

                        {/* <div className="w-32  flex justify-center items-center ">

                            {proj.TypeService} {""}
                        </div> */}
                        <div className="w-80 h-full  flex justify-between items-center">

                            <ShowApprovedTaskDetails
                                proj={proj}
                                index={index}
                                items={items}
                                tasks={tasks}
                                entries={entries}
                                employees={employees}
                                projectTrackingWorkEntries={projectTrackingWorkEntries}
                                hardwareProjectTracking={hardwareProjectTracking}
                                descriptionProjectTracking={descriptionProjectTracking}

                            />
                        </div>


                        <div className="w-32 h-full flex flex-col justify-center items-center ">
                            <ActionForwardApproved
                                ref={(el) => {
                                    dropdownRefsProbability.current[uniqueKey] = el;
                                }}
                                menuKey={uniqueKey}
                                openMenuKey={openProbabilityIndex}
                                setOpenMenuKey={setOpenProbabilityIndex}
                                disabled={isViewOnly}
                                isForwarded={proj.Assignedperson.some(
                                    (person) =>
                                        person.salespersonstatus === "project approved" &&
                                        person.managerstatus === "project assigned"
                                )}
                                onAccept={() => handleDirectAcceptProject(proj)}
                                onForward={() => handleAssignProject(proj)}
                                onCancelForwarded={() => {
                                    HandleManagerCancel(proj);
                                    setcancelProject(proj);
                                }}
                                childrenAfterForward={(() => {
                                    const manager = proj?.Assignedperson?.find((person) =>
                                        employees.some(
                                            (emp) =>
                                                emp.EmpEmail === person.email &&
                                                emp.customRoles?.includes("project manager")
                                        )
                                    );

                                    return (
                                        manager?.salespersonaction === "reject" &&
                                        manager.salespersonstatus === "project approved" && (
                                            <div
                                                className="p-1  bg-white hover:bg-gray-200 cursor-pointer"
                                                onClick={() => {
                                                    setOpenProbabilityIndex(null);
                                                    handleAssignProject(proj);
                                                }}
                                            >
                                                Reassign
                                            </div>
                                        )
                                    );
                                })()}
                            />
                        </div>
                    </div>
                )
            })}


            <div className=" flex  border-b">

                <div className="">
                    <div className="flex">
                        <div className="flex w-36 py-2 h-full  justify-center align-middle items-center">
                            <>
                                <div
                                    ref={newEmpDropdownRef}
                                    className="w-[90%] rounded-md relative flex justify-center text-xs align-middle items-center border border-gray-300 "
                                >
                                    <button
                                        disabled={isViewOnly}
                                        onClick={() => {
                                            if (isViewOnly) return;
                                            setNewEmpOpenDropdownIndex(newEmpOpenDropdownIndex === row ? null : row);
                                        }}
                                        className={`w-full text-xs px-2 py-2 truncate flex justify-between items-center ${isViewOnly ? "cursor-not-allowed opacity-50" : ""}`}
                                    >
                                        {newAssignedPeopleList[row.ProjectName + "_" + rowGroupId]?.[0]?.emp?.employeeId
                                            ? `${newAssignedPeopleList[row.ProjectName + "_" + rowGroupId][0].emp.employeeId.EmpFirstName} ${newAssignedPeopleList[row.ProjectName + "_" + rowGroupId][0].emp.employeeId.EmpLastName}`
                                            : "Select Resource"}
                                    </button>

                                    <ExpandMoreIcon
                                        onClick={() => {
                                            if (isViewOnly) return;
                                            setNewEmpOpenDropdownIndex(newEmpOpenDropdownIndex === row ? null : row);
                                        }}
                                        className={`ml-1 absolute right-0 bg-white ${isViewOnly ? "cursor-not-allowed opacity-50" : "group-hover:bg-gray-100"}`}
                                    />

                                    {newEmpOpenDropdownIndex === row && (
                                        <div className="absolute top-full left-0 max-w-26 max-h-52 overflow-y-auto bg-white border border-gray-300 shadow-lg z-50 narrow-scrollbar">
                                            {uniqueEmployeesnew.length > 0 ? (
                                                uniqueEmployeesnew.map((emp) => {
                                                    const fullName = `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`;
                                                    const empEmail = emp.employeeId?.EmpEmail;
                                                    const projectKey = `${row.ProjectName}_${rowGroupId}`;

                                                    // Fix: Properly check if this employee is selected
                                                    const isAssigned = newAssignedPeopleList[projectKey]?.some(person =>
                                                        person.email === empEmail
                                                    ) || false;

                                                    return (
                                                        <label
                                                            key={emp.employeeId?.id || emp.employeeId?._id}
                                                            className="flex justify-start align-middle items-center text-start px-2 py-1 text-xs bg-white hover:bg-gray-100"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                className="mr-2"
                                                                disabled={isViewOnly}
                                                                value={fullName}
                                                                checked={isAssigned}
                                                                onChange={(e) => {
                                                                    if (isViewOnly) return;
                                                                    const selectedValue = {
                                                                        name: fullName,
                                                                        email: empEmail,
                                                                        emp
                                                                    };
                                                                    const isChecked = e.target.checked;

                                                                    setNewAssignedPeopleList((prev) => {
                                                                        const projectKey = `${row.ProjectName}_${rowGroupId}`;
                                                                        const existing = prev[projectKey] || [];

                                                                        if (isChecked) {
                                                                            if (!existing.some((p) => p.email === empEmail)) {
                                                                                return {
                                                                                    ...prev,
                                                                                    [projectKey]: [...existing, selectedValue],
                                                                                };
                                                                            }
                                                                        } else {
                                                                            const updated = existing.filter((p) => p.email !== empEmail);

                                                                            if (updated.length === 0) {
                                                                                const newState = { ...prev };
                                                                                delete newState[projectKey];
                                                                                return newState;
                                                                            }

                                                                            return {
                                                                                ...prev,
                                                                                [projectKey]: updated
                                                                            };
                                                                        }

                                                                        return prev;
                                                                    });
                                                                }}
                                                            />
                                                            {fullName}
                                                        </label>
                                                    );
                                                })
                                            ) : (
                                                <div className="px-2 py-1 text-gray-500">No matching resources found.</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </>

                        </div>



                        <div className="w-80  h-full ">
                            <div className="flex justify-between items-center">
                                <div className="w-[50%] flex justify-center items-center align-middle">
                                </div>
                                <div className="w-[50%] flex justify-center items-center align-middle">
                                </div>

                            </div>
                        </div>
                    </div>
                    {Object.entries(newAssignedPeopleList).map(([projectKey, people]) => {
                        return (
                            <div key={projectKey} className="">
                                {people.map((person, idx) => (
                                    <div key={idx} className="flex justify-center items-center">
                                        <div className="w-36 p-2 h-full flex  justify-center items-center">
                                            {person.emp?.employeeId?.EmpFirstName} {person.emp?.employeeId?.EmpLastName}
                                        </div>
                                        <div className="w-80 p-2 h-full flex justify-center items-center">
                                            {person.emp?.employeeId?.servicetype} Manager
                                        </div>
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>

                <div className="flex justify-center items-center border-b w-32 py-2 ">
                    <ActionForwardApproved
                        ref={(el) => {
                            dropdownRefsProbability.current[newManagerActionMenuKey] = el;
                        }}
                        menuKey={newManagerActionMenuKey}
                        openMenuKey={openProbabilityIndex}
                        setOpenMenuKey={setOpenProbabilityIndex}
                        disabled={isViewOnly}
                        isForwarded={false}
                        newManagerMode
                        onAccept={() => handleDirectAcceptNewManagerProject()}
                        onForward={() => handleAssignNewManagerProject()}
                        rootClassName="w-[90%]"
                    />
                </div>

            </div>




            {confirmAssignPopup && (
                <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
                    <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] relative">
                        <div className="flex">
                            <h2 className="text-lg font-semibold">Project Name  : {row?.ProjectName}</h2>
                            <button
                                onClick={() => {
                                    setconfirmAssignPopup(false)
                                    setPopupEmpOpenDropdownIndex(!popupEmpOpenDropdownIndex)
                                }}
                                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                            >
                                Close
                            </button>
                        </div>

                        <p className="mt-2 text-[13px] text-start">
                            Are you sure you want to cancel this manager, <br />Then you need to select another Manager for this project?
                        </p>


                        <div className="flex justify-start align-middle items-center mt-3">
                            <div className="flex w-36 justify-start align-middle items-center">
                                <>
                                    <div
                                        ref={newEmpDropdownRef}
                                        className="w-[100%] max-w-32 rounded-md relative flex justify-center text-xs align-middle items-center border border-gray-300"
                                    >
                                        <button
                                            onClick={() => {
                                                setPopupEmpOpenDropdownIndex(!popupEmpOpenDropdownIndex)

                                            }}
                                            className="w-full text-xs px-2 py-2 truncate flex justify-between items-center max-w-26"
                                        >
                                            {(() => {
                                                const projectKey = `${row.ProjectName}_${rowGroupId}`;
                                                const firstEmp = popupassignedPeopleList?.[projectKey]?.[0];

                                                if (firstEmp?.emp?.employeeId) {
                                                    return `${firstEmp.emp.employeeId.EmpFirstName} ${firstEmp.emp.employeeId.EmpLastName}`;
                                                }
                                                return "Select Resource";
                                            })()}

                                        </button>

                                        <ExpandMoreIcon
                                            onClick={() =>
                                                setPopupEmpOpenDropdownIndex(!popupEmpOpenDropdownIndex)
                                            }
                                            className={`ml-1 absolute right-0 cursor-pointer bg-white ${'group-hover:bg-gray-100'}`}
                                        />

                                        {popupEmpOpenDropdownIndex && (
                                            <div className="absolute top-full left-0 max-w-26 max-h-52 overflow-y-auto bg-white border border-gray-300 shadow-lg z-50 narrow-scrollbar">
                                                {popupuniqueEmployeesnew.length > 0 ? (
                                                    popupuniqueEmployeesnew.map((emp) => {
                                                        const fullName = `${emp.employeeId?.EmpFirstName} ${emp.employeeId?.EmpLastName}`;
                                                        const empEmail = emp.employeeId?.EmpEmail;
                                                        const projectKey = `${row.ProjectName}_${rowGroupId}`;

                                                        // Fix: Properly check if this employee is selected
                                                        const isAssigned = popupassignedPeopleList[projectKey]?.some(person =>
                                                            person.email === empEmail
                                                        ) || false;

                                                        return (
                                                            <label
                                                                key={emp.employeeId?.id || emp.employeeId?._id}
                                                                className="flex justify-between align-middle items-center px-2 py-1 text-xs bg-white hover:bg-gray-100"
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    className="mr-2"
                                                                    disabled={isViewOnly}
                                                                    value={fullName}
                                                                    checked={isAssigned}
                                                                    onChange={(e) => {
                                                                        if (isViewOnly) return;
                                                                        const selectedValue = {
                                                                            name: fullName,
                                                                            email: empEmail,
                                                                            emp
                                                                        };
                                                                        const isChecked = e.target.checked;

                                                                        setpopupassignedPeopleList((prev) => {
                                                                            const projectKey = `${row.ProjectName}_${rowGroupId}`;
                                                                            const existing = prev[projectKey] || [];

                                                                            if (isChecked) {
                                                                                if (!existing.some((p) => p.email === empEmail)) {
                                                                                    return {
                                                                                        ...prev,
                                                                                        [projectKey]: [...existing, selectedValue],
                                                                                    };
                                                                                }
                                                                            } else {
                                                                                const updated = existing.filter((p) => p.email !== empEmail);

                                                                                if (updated.length === 0) {
                                                                                    const newState = { ...prev };
                                                                                    delete newState[projectKey];
                                                                                    return newState;
                                                                                }

                                                                                return {
                                                                                    ...prev,
                                                                                    [projectKey]: updated
                                                                                };
                                                                            }

                                                                            return prev;
                                                                        });
                                                                        setPopupEmpOpenDropdownIndex(null)
                                                                    }}
                                                                />
                                                                {fullName}
                                                            </label>
                                                        );
                                                    })
                                                ) : (
                                                    <div className="px-2 py-1 text-gray-500">No matching resources found.</div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </>

                            </div>
                        </div>

                        <div className="flex justify-start gap-4 mt-6">
                            {/* <button
                                onClick={modalManagerCancel}
                                className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                            >
                                Yes
                            </button> */}
                            <button
                                onClick={() => { if (!isViewOnly) modalManagerCancel(); }}
                                disabled={isDisabled || isViewOnly}
                                className={`py-2 px-7 rounded-lg 
                                  ${(isDisabled || isViewOnly)
                                        ? "bg-gray-300 cursor-not-allowed text-gray-600"
                                        : "bg-[#e32278] text-white cursor-pointer"
                                    }`}
                            >
                                Yes
                            </button>

                            <button
                                onClick={() => {
                                    setconfirmAssignPopup(false)
                                }}
                                className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProjectApprovedSub
